import type { TTMLLyric } from "$/types/ttml";

/**
 * 歌詞をプレーンテキストに変換する。1 行の歌詞を 1 行として出力し、空行は含めない。
 */
export default function exportPlainText(ttmlLyric: TTMLLyric): string {
	return ttmlLyric.lyricLines
		.map((line) =>
			line.words
				.map((word) => word.word)
				.join("")
				.trim(),
		)
		.filter((text) => text.length > 0)
		.join("\n");
}
